import * as helper from './../../../Assets/Js/helper';
import {initImprint} from '../../../Assets/Js/VXImprint';

export function ImprintHandler() {
	const imprintLink = helper.$('#impressumlink');
	const datenschutzlink = helper.$('#datenschutzlink');

	initImprint(imprintLink, datenschutzlink);
}
